<template>
  <v-card tile flat class="grey lighten-4 rounded-t-xl">
    <v-card-title class="pa-0">
      <v-toolbar flat class="grey lighten-4 rounded-t-xl transparent">
        <v-btn icon @click="selectPaymentMethod" :title="$t('buttons.confirm')">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ $t('selectPaymentMethod') }}
        </v-toolbar-title>
        <v-btn icon disabled transparent></v-btn>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="overflow-y-auto" :style="$vuetify.breakpoint.height < 700 ? 'max-height: 65vh' : ''">
      <v-radio-group v-model="index" mandatory @change="selectPaymentMethod">
        <v-card 
          v-for="(paymentMethod, methodIndex) in paymentMethods" 
          :key="methodIndex"
          class="mb-2 white elevation-0 rounded" 
          flat
        >
          <v-radio
            :id="`${paymentMethod.title}-select`"
            :label="paymentMethod.title"
            :value="methodIndex"
            class="ma-0 pa-4"
          ></v-radio>
        </v-card>
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PaymentMethodSelectionScreen',
  data() {
    return {
      index: 0,
    };
  },
  computed: {
    paymentMethods() {
      return this.$store.getters.paymentMethods;
    },
    selectedPaymentMethod: {
      get() {
        return this.$store.getters.selectedPaymentMethod;
      },
      set(value) {
        this.$store.commit('updateSelectedPaymentMethod', value);
      },
    },
  },
  mounted() {
    if (this.selectedPaymentMethod) {
      this.index = this.paymentMethods.findIndex(method => method.uuid === this.selectedPaymentMethod.uuid);
    }
  },
  methods: {
    selectPaymentMethod() {
      if (this.paymentMethods.length) {
        this.selectedPaymentMethod = this.paymentMethods[this.index];
      }

      this.$emit('close');
    },
  }
}
</script>
